export default function ProjectTitle(props) {
    const name = props.title.title
    const type = props.title.type
    return <div className="poject_title_area">
        <div className="poject_title_name"><h1>{name}</h1></div>
        <div className="poject_title_type"><h1>{type}</h1></div>
    </div>
}